export default __webpack_public_path__ + "static/media/odyssey-sm-logo.ee7de2bd.svg";